import { theme } from "shared/lib/styles";

import type { ConfigProps } from "scmp-app/components/advertisement/ad-slots/ad-slot";
import { TargetingPaidType } from "scmp-app/components/advertisement/ad-slots/types";
import {
  PostMagazineSectionTopWidgetOne,
  PostMagazineSectionTopWidgetThree,
  PostMagazineSectionTopWidgetTwo,
} from "scmp-app/components/post-magazine/section-top-widget";

import type { WidgetMap } from "./types";

export const getDefaultAdSlotProps = (sectionId: string, adZone: string) =>
  ({
    targeting: {
      paid: TargetingPaidType.NotArticle,
      scsid: [sectionId],
    },
    withBackground: true,
    withLabel: true,
    withSticky: true,
    zone: adZone,
  }) satisfies ConfigProps;

export const getWidgetsMap = (
  defaultAdSlotProps: ReturnType<typeof getDefaultAdSlotProps>,
): { [key: number]: WidgetMap } => ({
  0: {
    component: PostMagazineSectionTopWidgetOne,
    props: {
      adsConfigs: [
        [
          {
            ...defaultAdSlotProps,
            adUnit: "d_lrec2",
            breakpoint: theme.breakpoints.up("desktop"),
            sizes: [[300, 250]],
          },
          {
            ...defaultAdSlotProps,
            adUnit: "m_lrec2",
            breakpoint: theme.breakpoints.only("tablet"),
            sizes: [[300, 250]],
          },
          {
            ...defaultAdSlotProps,
            adUnit: "m_lrec1",
            breakpoint: theme.breakpoints.only("mobile"),
            sizes: [[300, 250]],
          },
        ],
        [
          {
            ...defaultAdSlotProps,
            adUnit: "d_native2a",
            breakpoint: theme.breakpoints.up("desktop"),
            sizes: [[1, 1], "fluid"],
            withBackground: false,
            withLabel: false,
            withLabelBackground: false,
          },
          {
            ...defaultAdSlotProps,
            adUnit: "m_native2a",
            breakpoint: theme.breakpoints.only("tablet"),
            sizes: [[1, 1], "fluid"],
            withBackground: false,
            withLabel: false,
            withLabelBackground: false,
          },
          {
            ...defaultAdSlotProps,
            adUnit: "m_native2a",
            breakpoint: theme.breakpoints.only("mobile"),
            sizes: [[1, 1], "fluid"],
            withBackground: false,
            withLabel: false,
            withLabelBackground: false,
          },
        ],
      ],
      label: "Latest",
      variant: "withFiveArticle",
    },
  },
  1: {
    component: PostMagazineSectionTopWidgetOne,
    props: { variant: "withThreeArticle" },
  },
  2: {
    component: PostMagazineSectionTopWidgetOne,
    props: {
      adsConfigs: [
        [
          {
            ...defaultAdSlotProps,
            adUnit: "d_lrec3",
            breakpoint: theme.breakpoints.up("desktop"),
            sizes: [[300, 250]],
          },
          {
            ...defaultAdSlotProps,
            adUnit: "m_lrec3",
            breakpoint: theme.breakpoints.only("tablet"),
            sizes: [[300, 250]],
          },
          {
            ...defaultAdSlotProps,
            adUnit: "m_lrec3",
            breakpoint: theme.breakpoints.only("mobile"),
            sizes: [[300, 250]],
          },
        ],
      ],
    },
  },
  3: {
    component: PostMagazineSectionTopWidgetOne,
    props: { variant: "withThreeArticle" },
  },
  4: {
    component: PostMagazineSectionTopWidgetTwo,
  },
  5: {
    component: PostMagazineSectionTopWidgetOne,
    props: {
      adsConfigs: [
        [
          {
            ...defaultAdSlotProps,
            adUnit: "d_lrec4",
            breakpoint: theme.breakpoints.up("desktop"),
            sizes: [[300, 250]],
          },
          {
            ...defaultAdSlotProps,
            adUnit: "m_lrec4",
            breakpoint: theme.breakpoints.only("tablet"),
            sizes: [[300, 250]],
          },
          {
            ...defaultAdSlotProps,
            adUnit: "m_lrec4a",
            breakpoint: theme.breakpoints.only("mobile"),
            sizes: [[300, 250]],
          },
        ],
      ],
    },
  },
  6: {
    component: PostMagazineSectionTopWidgetThree,
  },
});
